import { render, staticRenderFns } from "./RenxiaoAsideMenu.vue?vue&type=template&id=366c9eea&scoped=true"
import script from "./RenxiaoAsideMenu.vue?vue&type=script&lang=js"
export * from "./RenxiaoAsideMenu.vue?vue&type=script&lang=js"
import style0 from "./RenxiaoAsideMenu.vue?vue&type=style&index=0&id=366c9eea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.38_css-loader@7.1.4_@rspack+core@1.6.4_webpack_852858acfdff260959c5a19d045c9569/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366c9eea",
  null
  
)

export default component.exports